import { AxiosError } from "axios";

// The server's messages are English, so the mechanic gets a Dutch one per outcome of /auth/azure-login.
export function loginError(e: Error | AxiosError): string {
  if (!(e as AxiosError).isAxiosError) {
    return "Inloggen bij Microsoft is mislukt. Probeer het opnieuw.";
  }

  const response = (e as AxiosError).response;

  if (!response) {
    return "Geen verbinding met de server.";
  }

  if (response.status === 401) {
    return "Uw Microsoft-account heeft geen toegang tot de monteursapp. Neem contact op met uw installatiebedrijf.";
  }

  if (response.status === 403) {
    return "Uw account is gedeactiveerd. Neem contact op met uw installatiebedrijf.";
  }

  return "Inloggen is mislukt. Probeer het opnieuw.";
}
